module.exports = __webpack_public_path__ + "img/Icon Communication.2359b793.png";